module.exports = __webpack_public_path__ + "img/DE00459.f3ffc38a.png";